/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Starter_1Inputs */

const en_signup_feature_starter_1 = /** @type {(inputs: Signup_Feature_Starter_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One (1) user license`)
};

const fr_signup_feature_starter_1 = /** @type {(inputs: Signup_Feature_Starter_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une (1) licence utilisateur`)
};

const de_signup_feature_starter_1 = /** @type {(inputs: Signup_Feature_Starter_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine (1) Benutzerlizenz`)
};

const it_signup_feature_starter_1 = /** @type {(inputs: Signup_Feature_Starter_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una (1) licenza utente`)
};

const ru_signup_feature_starter_1 = /** @type {(inputs: Signup_Feature_Starter_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Одна (1) пользовательская лицензия`)
};

const es_signup_feature_starter_1 = /** @type {(inputs: Signup_Feature_Starter_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una (1) licencia de usuario`)
};

const zh_cn2_signup_feature_starter_1 = /** @type {(inputs: Signup_Feature_Starter_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一个（1）用户许可证`)
};

const ja_signup_feature_starter_1 = /** @type {(inputs: Signup_Feature_Starter_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1ユーザーライセンス`)
};

const hi_signup_feature_starter_1 = /** @type {(inputs: Signup_Feature_Starter_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक (1) उपयोगकर्ता लाइसेंस`)
};

const pt_pt2_signup_feature_starter_1 = /** @type {(inputs: Signup_Feature_Starter_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma (1) licença de usuário`)
};

/**
* | output |
* | --- |
* | "One (1) user license" |
*
* @param {Signup_Feature_Starter_1Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_starter_1 = /** @type {((inputs?: Signup_Feature_Starter_1Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Starter_1Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_feature_starter_1(inputs)
	if (locale === "de") return de_signup_feature_starter_1(inputs)
	if (locale === "it") return it_signup_feature_starter_1(inputs)
	if (locale === "ru") return ru_signup_feature_starter_1(inputs)
	if (locale === "es") return es_signup_feature_starter_1(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_feature_starter_1(inputs)
	if (locale === "ja") return ja_signup_feature_starter_1(inputs)
	if (locale === "hi") return hi_signup_feature_starter_1(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_feature_starter_1(inputs)
	return en_signup_feature_starter_1(inputs)
});